import { SxProps, Theme } from '@mui/material';

export const labelStyles: SxProps<Theme> = [
	{
		textAlign: 'center',
		mb: 6,
		color: (theme) => theme.colors.gray,
	},
];

export const titleStyles: SxProps<Theme> = [
	{
		// mt: 3,
		mb: '35px',
		textAlign: 'center',
		fontWeight: '500',
		fontSize: '24px',
		lineHeight: '120%',
	},
	({ breakpoints }) => ({
		[breakpoints.down('sm')]: {
			my: 3,
			fontSize: '20px',
		},
	}),
];

export const textFieldWrapperStyles: SxProps<Theme> = [
	{ mb: 4 },
	({ breakpoints }) => ({
		[breakpoints.down('sm')]: {
			mb: 2,
		},
	}),
];
